import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getAnnouncements } from "../store/actions/news"
import { getAnnouncementsState } from "../store/selectors/news"
import { useLocation } from "react-router"
import CloseButton from "./CloseButton"

const MegaphoneIcon = ({svgClass}) => ( /* https://heroicons.com/ */
  <svg className={svgClass} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 1 1 0-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 0 1-1.44-4.282m3.102.069a18.03 18.03 0 0 1-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 0 1 8.835 2.535M10.34 6.66a23.847 23.847 0 0 0 8.835-2.535m0 0A23.74 23.74 0 0 0 18.795 3m.38 1.125a23.91 23.91 0 0 1 1.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 0 0 1.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 0 1 0 3.46" />
  </svg>
)

const LOCAL_STORAGE_GENERAL_ANNOUNCEMENTS = 'hide_announcements';

const GeneralAnnouncements = () => {
  const [hiddenAnnouncements, setHiddenAnnouncements] = useState(JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_GENERAL_ANNOUNCEMENTS)) ?? [])
  const dispatch = useDispatch();
  const language = useSelector(state => state.language);
  const location = useLocation();
  const news = useSelector(state => getAnnouncementsState(state))
  useEffect(() => {
    dispatch(getAnnouncements())
  }, [location])

  const hideAnnouncement = (id) => {
    const newsIds = news.map(n => n.id);
    const hiddenToSave = hiddenAnnouncements.filter(id => newsIds.includes(id)).concat(id);
    window.localStorage.setItem(LOCAL_STORAGE_GENERAL_ANNOUNCEMENTS, JSON.stringify(hiddenToSave));
    setHiddenAnnouncements(hiddenToSave);
  }

  return (
        <div className="container">
            {Array.isArray(news) && news
              .filter(n => !(hiddenAnnouncements.includes(n.id)))
              .map( n => (
              <article key={n.id} className="general-announcement">
                <MegaphoneIcon svgClass="general-announcement--icon" />
                <div className="general-announcement--text-container">
                  <h1>{n.i18n[language].title}&nbsp;</h1>
                  <p>{n.i18n[language].content}</p>
                </div>
                <div className="close-container">
                  <CloseButton closeToast={() => {hideAnnouncement(n.id)}} />
                </div>
              </article>
            ))}
        </div>
  )

}

export default GeneralAnnouncements;